<template>
    <rkm-overlay>
        <rkm-layout-body title="C4 - Cuidado da pessoa com diabetes">
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import List from '@/components/atencao-basica/relatorio-cuidado-pessoa-com-diabete/List'

export default {
    components: {List},
}
</script>